import { Component, OnInit, Input, DoCheck, OnDestroy } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { UtilsService } from 'src/app/services/utils.service';
import { MANAGE_LINE_CONST, COMMON_CONSTANTS } from '../../../common/core/common.constants';
import * as _ from 'lodash';
import { UntypedFormControl, Validators } from '@angular/forms';
import { LoaderService } from 'src/app/services/loader.service';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
@Component({
  selector: 'app-change-number-form',
  templateUrl: './change-number-form-component.html',
  styleUrls: ['./change-number-form-component.scss'],
})
export class ChangeNumberFormComponent implements OnInit, DoCheck, OnDestroy {
  reasonForDDChanges;
  chooseNumberByPlaceholder;
  @Input() singleLineFlow = false;
  @Input() removeLineIndex;
  @Input() msisdn;
  @Input() singleSetting;
  @Input() totalSelectedLines;
  @Input() assignAll;

  multiSelectedNpa = [];
  totalMultiLinesSelected = 0;

  reasonError: boolean = false;
  reasonErrorMessage: string;
  npxQueryType: string;
  errorMessage: string;
  npaNpxResponse: any = [];
  npaNpxValue: string;
  areaCodeValidation;
  msidnChangeReasonData: any;
  reasonForMsisdnChanges: any;
  requestBody: any = {};
  reasonId: string;
  reasonCode: string;
  isNpaNpxEnable = false;
  isnpxErrorMsgEnable = false;
  msisdnChangeValidatorErrorMsg: string;
  enableMsisdnChangeValidatorErrorMsg = false;
  authoringContentData: any;
  changeNumberByDD = MANAGE_LINE_CONST.PREFERENCE_CODES;
  zipCode: UntypedFormControl;
  reasonValue: UntypedFormControl;
  areaCodeValue: UntypedFormControl;
  npxNpaValue: UntypedFormControl;
  areaCodeInput: string;
  selectToggle = true;
  enableNextSetting = false;
  npaNpxNumber: any = [];
  lookUpFieldArray = [];
  isVisibleLookUpField = false;
  areaNumberCount = 1;
  callCounter = 0;
  selectedReason: any;
  selectedChooseNumberBy: any;
  orgId: any;
  newSetofNxx: any[];
  constructor(public manageLineService: ManageLineService, private _helperUtilSvc:HelperUtilityService,
    public utilsSvc: UtilsService, private _cacheSvc: HttpCacheService, private _loaderSvc: LoaderService) { }

  ngOnInit(): void {
    this.zipCode = new UntypedFormControl('', [Validators.required]);
    this.reasonValue = new UntypedFormControl('', [Validators.required]);
    this.areaCodeValue = new UntypedFormControl('', [Validators.required]);
    this.npxNpaValue = new UntypedFormControl('', [Validators.required]);
    this.orgId = this._helperUtilSvc.getOrgID();
    this.authoringContentData = this.utilsSvc.getContentDataFromSession().changeNumberAuthoring;
    this.zipCode = new UntypedFormControl(this.changeNumberByDD[0].name);
    this.selectedChooseNumberBy = this.zipCode.value;

    this.manageLineService.changeNumberReasons().subscribe((response) => {
      this.msidnChangeReasonData = response.msisdnChangeReasons;
      if(this.manageLineService?.storeMultiLineData){ 
        this.callSelectReason();
      }else{
        this.reasonValue = new UntypedFormControl(this.msidnChangeReasonData[0].description);
        this.selectReason(this.msidnChangeReasonData[0]);
        this.chooseNumberBy(this.changeNumberByDD[0], null);
        this.selectedReason = this.reasonValue.value;
      }  
    });
    this.areaCodeValidation = COMMON_CONSTANTS.DIGITS.THREE;
    if (this.singleSetting) {
      this.manageLineService.storeMultiLineData = null;
    }
    if (!isNullOrUndefined(this.manageLineService.storeMultiLineData) && !this.singleSetting) {
      const response = this.manageLineService.storeMultiLineData;
      this.reasonForMsisdnChanges = _.get(response, 'reasonForMsisdnChanges', '');
      this.reasonId = _.get(response, 'reasonId', '');
      this.reasonCode = _.get(response, 'reasonCode', '');
      this.reasonForDDChanges = _.get(response, 'reasonForDDChanges', '');
      this.chooseNumberByPlaceholder = _.get(response, 'chooseNumberByPlaceholder', '');
      this.npxQueryType = _.get(response, 'npxQueryType', '');
      this.areaCodeValidation = _.get(response, 'areaCodeValidation', '');
      this.areaCodeInput = _.get(response, 'areaCodeInput', '');
      this.npaNpxResponse = _.get(response, 'npaNpxResponse', []);
      this.npaNpxNumber = _.get(response, 'npaNpxNumber', []);
      const npaObject = { 'value': this.npaNpxNumber[this.callCounter],'reasonCode':this.reasonCode,'reasonId':this.reasonId };
      if (_.isEmpty(npaObject.value)) {
        return;
      }
      const npaNpxObjectValue = {
       'itemText': npaObject.value,
        'itemCount': _.filter(this.npaNpxNumber, function (o) { return o === npaObject.value; }).length,
        'authorContent': this.authoringContentData.availableLines
      };

      this.createForm(response, npaNpxObjectValue);

     this.npaNpxNumber = this.npaNpxNumber.filter((x, i, a) => a.indexOf(x) === i);
     if(this.npaNpxNumber.length == 1){
         this.requestedBody(npaObject);
     }
    this.callCounter++;
    }
    this.manageLineService.notifyChangeNumberFlow.subscribe((response: any) => {
      if (response.id === 'emptyForm') {
        response = this.manageLineService.storeMultiLineData;
        this.reasonForMsisdnChanges = _.get(response, 'reasonForMsisdnChanges', '');
        this.reasonId = _.get(response, 'reasonId', '');
        this.reasonCode = _.get(response, 'reasonCode', '');
        this.reasonForDDChanges = _.get(response, 'reasonForDDChanges', '');
        this.chooseNumberByPlaceholder = _.get(response, 'chooseNumberByPlaceholder', '');
        this.npxQueryType = _.get(response, 'npxQueryType', '');
        this.areaCodeValidation = _.get(response, 'areaCodeValidation', '');
        this.areaCodeInput = _.get(response, 'areaCodeInput', '');
        this.npaNpxResponse = _.get(response, 'npaNpxResponse', []);
        this.npaNpxNumber = _.get(response, 'npaNpxNumber', []);
        this.zipCode = new UntypedFormControl('', [Validators.required]);
        this.reasonValue = new UntypedFormControl('', [Validators.required]);
        this.selectedReason = "";
        this.areaCodeValue = new UntypedFormControl('', [Validators.required]);
        this.npxNpaValue = new UntypedFormControl('', [Validators.required]);
        this.manageLineService.callCounter = 0;
      }
    });

  }

  callSelectReason(){
    let item = this.manageLineService?.storeMultiLineData;
    this.reasonValue = new UntypedFormControl(item.reasonForMsisdnChanges);
      let selectedReason ={};
      for(let i of this.msidnChangeReasonData){
        if(item.reasonForMsisdnChanges == i.description){
            selectedReason=(i);
          }
        }
      this.selectReason(selectedReason);
      this.chooseNumberBy(this.changeNumberByDD[0], null);
      this.selectedReason = this.reasonValue.value;
      this.reasonError = false;
  }

  createForm(item: any, npxitem: any) {
    this.zipCode = new UntypedFormControl(item.reasonForDDChanges);
    this.reasonValue = new UntypedFormControl(item.reasonForMsisdnChanges);
    this.areaCodeValue = new UntypedFormControl(item.areaCodeInput);
    this.npxNpaValue = new UntypedFormControl(npxitem.itemText);
    this.selectedReason = this.reasonValue.value;
    this.selectedChooseNumberBy = this.zipCode.value;
  }

  selectReason(reason) {
    this.reasonForMsisdnChanges = reason.description;
    this.reasonId = reason.id;
    this.reasonCode = reason.code;
    this.selectedReason = reason.description;
    if (this.areaCodeValue.value !== "") {
      const event = {target : {value: (this.areaCodeValue.value).toString()} };
      this.reasonError = false;
      this.NpaNxxLookup(event);
    }

    const index = _.findIndex(this.manageLineService.changeNumberFlowResponseBody, (items) => {
      return items.oldMsisdn === this.msisdn;
    });

    if (index != -1) {
      // When reason codes change need to update body with correct reasonCode
      this.manageLineService.changeNumberFlowResponseBody[index].reasonCode = reason.code;
      this.manageLineService.changeNumberFlowResponseBody[index].reasonId = reason.id;
    }
    this.manageLineService.notifyChangeNumberFlow.next({ 'id': MANAGE_LINE_CONST.CHANGE_NUMBER_REASON, 'reasonCode': reason.id });
  }

  chooseNumberBy(reason, index?) {
    this.reasonForDDChanges = reason.name;
    this.chooseNumberByPlaceholder = this.isVisibleLookUpField ? this.chooseNumberByPlaceholder : reason.name;
    this.manageLineService.isCheckBoxDisabled = true;
    this.manageLineService.notifyChangeNumberFlow.next({ 'id': MANAGE_LINE_CONST.DISABLE_CHECKBOX });
    this.npxQueryType = reason.value;
    if (_.isNumber(index)) {
      // tslint:disable-next-line:max-line-length
      this.lookUpFieldArray[index].areaCodeValues='';
      this.lookUpFieldArray[index].areaCodeValidation = reason.value === MANAGE_LINE_CONST.ZIP_CODE ? COMMON_CONSTANTS.DIGITS.FIVE : COMMON_CONSTANTS.DIGITS.THREE;
    } else {
     
      this.areaCodeValidation = reason.value === MANAGE_LINE_CONST.ZIP_CODE ? COMMON_CONSTANTS.DIGITS.FIVE : COMMON_CONSTANTS.DIGITS.THREE;
    }
    this.clearErrors(null, index);
    this.manageLineService.notifyChangeNumberFlow.next({ 'id': MANAGE_LINE_CONST.DISABLE_CHECKBOX });
  }
  requestedBody(item) {
    let body = this.createRequestedBody(item);

    this.manageLineService.changeNumberEligibility(body).subscribe((response) => {
      if (!_.isEmpty(response) && response.status === MANAGE_LINE_CONST.SUCCESS) {
        if (!isNullOrUndefined(this.singleSetting) && !this.singleSetting) {
          this.manageLineService.notifyChangeNumberFlow.next({ 'id': 'successValidator', 'index': this.removeLineIndex });
        }
        this.MapChangeNumberRequestBody(item);
        const index = _.findIndex(this.manageLineService.changeNumberFlowResponseBody, (items) => {
          return items.oldMsisdn === this.msisdn;
        });

        this.verifyIndexAndPush(index);

        this.manageLineService.isCheckBoxDisabled = false;
        this.manageLineService.notifyChangeNumberFlow.next({ 'id': 'enableCheckBox' });

      } else {
        this.msisdnChangeValidatorErrorMsg = response.message;
        this.enableMsisdnChangeValidatorErrorMsg = true;
        if (!this.singleSetting) {
          this.manageLineService.notifyChangeNumberFlow.next({ 'id': 'errorValidator', 'index': this.removeLineIndex });
        }
      }

    }, (error) => {
      this.manageLineService.close();
      this.utilsSvc.errorHandling(error);
    });
  }

  createRequestedBody(item) {
    let body = {};
    if (!_.isEmpty(item.value)) {
      body = {
        npa: item.value.match(/.{1,3}/g)[0],
        nxx: item.value.match(/.{1,3}/g)[1],
        mobileNumber: this.msisdn
      };
    }
    return body;
  }

  verifyIndexAndPush(index){
    if (index === -1) {
      this.manageLineService.changeNumberFlowResponseBody.push(this.requestBody);

    } else {
      this.manageLineService.changeNumberFlowResponseBody[index] = this.requestBody;
    }
  }

  MapChangeNumberRequestBody(item){
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
        this.requestBody.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
        this.requestBody.reasonCode = !_.isEmpty(item.reasonCode) ? item.reasonCode : this.reasonCode;
        this.requestBody.reasonId = !_.isEmpty(item.reasonId) ? item.reasonId : this.reasonId;
        this.requestBody.logonId = !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
        this.requestBody.email = !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
        this.requestBody.orgId = this.orgId;
        this.requestBody.effectiveDate = (new Date).toISOString();
        this.requestBody.npa = item.value.match(/.{1,3}/g)[0];
        this.requestBody.nxx = item.value.match(/.{1,3}/g)[1];
        this.requestBody.oldMsisdn = this.msisdn;
  }
  NpaNxxLookup(event, index?: any) {
    this._loaderSvc.start();
    if (event.target.value.toString() !== '') {
      this.manageLineService.isCheckBoxDisabled = false;
    } else {
      this.manageLineService.isCheckBoxDisabled = true;
      this.manageLineService.notifyChangeNumberFlow.next({ id: MANAGE_LINE_CONST.DISABLE_CHECKBOX });
    }
    if (!_.isEmpty(event.target.value) && event.target.value.length === this.areaCodeValidation ||
      this.lookUpFieldArray.length > 0 && this.lookUpFieldArray[index].areaCodeValidation === event.target.value.length) {
      const itemExist: any = _.filter(this.npaNpxResponse, (item) => {
        return item.uniqueId === event.target.value;
      });
      if(isNullOrUndefined(this.selectedReason) || _.isEmpty(this.selectedReason) ){
        this.reasonErrorMessage = MANAGE_LINE_CONST.REASON_FOR_CHANGE_ERROR;
        this.reasonError = true;
        this._loaderSvc.stop();
        return;
      }
      if (itemExist.length > 0) {
        this._loaderSvc.stop();
        return;
      }
      this.areaCodeInput = event.target.value;
      this.manageLineService.NpaNxxLookupServiceRequest(event.target.value, this.npxQueryType).subscribe((response) => {
        response.npaNxx = _.forEach(response.npaNxx, (item) => {
          item.uniqueId = event.target.value;
        });
        if (this.isVisibleLookUpField) {
          this.npaNpxResponse = [...this.npaNpxResponse, ...response.npaNxx];
          this.areaNumberCount = this.lookUpFieldArray.length + 1;
        } else {
          this.npaNpxResponse = response.npaNxx;
        }
        // By default selecing first value in preferred nxx dropdown
        // this.npxNpaValue = new FormControl(this.npaNpxResponse[0].npaNxx);
        this.isNpaNpxEnable = true;
        this.isnpxErrorMsgEnable = false;
        this._loaderSvc.stop();
        this.manageLineService.isCheckBoxDisabled = true;
        this.manageLineService.notifyChangeNumberFlow.next({ 'id': MANAGE_LINE_CONST.DISABLE_CHECKBOX });


      }, (err) => {

          if (_.isNumber(index)) {
            this.lookUpFieldArray[index].errorMessage = err.error.error[0].userMessage;
            this.lookUpFieldArray[index].isnpxErrorMsgEnable = true;
          } else {
            if (!isNullOrUndefined(err) && !isNullOrUndefined(err.error) && !isNullOrUndefined(err.error.error[0])) {
              this.errorMessage = err.error.error[0].userMessage;
              this.isnpxErrorMsgEnable = true;
              if(!isNullOrUndefined(this.removeLineIndex)) {
                this.manageLineService.notifyChangeNumberFlow.next({ 'id': 'errorValidator', 'index': this.removeLineIndex });
              }
            }
          }
          this._loaderSvc.stop();
        });
    } else {
      if (_.isNumber(index)) {
        this.lookUpFieldArray[index].errorMessage = MANAGE_LINE_CONST.NPA_ERROR_MSG;
        this.lookUpFieldArray[index].isnpxErrorMsgEnable = true;
      } else {
        this.errorMessage = MANAGE_LINE_CONST.NPA_ERROR_MSG;
        this.isnpxErrorMsgEnable = true;
        if(!isNullOrUndefined(this.removeLineIndex)) {
          this.manageLineService.notifyChangeNumberFlow.next({ 'id': 'errorValidator', 'index': this.removeLineIndex });
        }
      }
      this._loaderSvc.stop();
    }
  }
  clearErrors(event, index?) {

    if (!_.isNumber(index) && !isNullOrUndefined(event)  && !isNullOrUndefined(event.target)
    && !isNullOrUndefined(event.target.value) && event.target.value.length >  this.areaCodeValidation) {
      event.target.value = event.target.value.substring(0, this.areaCodeValidation);
    }
    if (_.isNumber(index) && !isNullOrUndefined(event)  && !isNullOrUndefined(event.target)
    && !isNullOrUndefined(event.target.value) && event.target.value.length >  this.lookUpFieldArray[index].areaCodeValidation) {
        event.target.value = event.target.value.substring(0, this.lookUpFieldArray[index].areaCodeValidation);
    }
    this.isnpxErrorMsgEnable = false;
    if (!this.isVisibleLookUpField) {
      this.setNxxDropdownValues();
    }
    this.enableMsisdnChangeValidatorErrorMsg = false;
    if (_.isNumber(index)) {
      this.lookUpFieldArray[index].isnpxErrorMsgEnable = false;
      this.lookUpFieldArray[index].areaCodeValues = '';
    }
  }
  setNxxDropdownValues(){
    this.npaNpxNumber = this.npaNpxNumber.filter((x, i, a) => a.indexOf(x) === i);
      if(this.npaNpxNumber.length > 1){
        this.npxNpaValue = new UntypedFormControl('');
      }
      this.newSetofNxx = [];
      this.isNpaNpxEnable = false;
      if(this.npaNpxNumber.length > 0 && this.npaNpxResponse.length > 0){
        for(let i of this.npaNpxResponse){
          for(let j of this.npaNpxNumber){
            if(j == i.npaNxx){
              this.newSetofNxx.push(i);
            }
          }
        }
        
      this.newSetofNxx = this.newSetofNxx.filter((x, i, a) => a.indexOf(x) === i);
      this.npaNpxResponse =[];
      this.npaNpxResponse = this.npaNpxResponse.concat(this.newSetofNxx);
      }      
  }
  ngDoCheck() {
    if (this.singleSetting) {
      const singleLineObject: any = {};
      singleLineObject.reasonForMsisdnChanges = this.reasonForMsisdnChanges;
      singleLineObject.reasonId = this.reasonId;
      singleLineObject.reasonCode = this.reasonCode;
      singleLineObject.reasonForDDChanges = this.reasonForDDChanges;
      singleLineObject.chooseNumberByPlaceholder = this.chooseNumberByPlaceholder;
      singleLineObject.npxQueryType = this.npxQueryType;
      singleLineObject.areaCodeValidation = this.areaCodeValidation;
      singleLineObject.areaCodeInput = this.areaCodeInput;
      singleLineObject.npaNpxResponse = this.npaNpxResponse;
      singleLineObject.npaNpxNumber = this.npaNpxNumber;
      let item = false;
      _.forEach(singleLineObject, function (value, key) {
        if (value !== undefined) {
          item = true;
        }
      });
      if (item) {
        this.manageLineService.storeMultiLineData = singleLineObject;
      }

    }
  }
  updateSelectedLines(event, line) {
    if(event.checked){
      const isItemExist = this.multiSelectedNpa.findIndex(x => x.npaNxx === line.npaNxx);
      if (isItemExist === -1) {
        this.multiSelectedNpa.push(line);
      } else {
        this.multiSelectedNpa.splice(isItemExist, 1);
      }
      this.multiSelectedNpa = this.multiSelectedNpa.filter((x, i, a) => a.indexOf(x) === i);
      this.totalMultiLinesSelected = _.sumBy(this.multiSelectedNpa, function (item) { return +item.availableCount; });
      this.enableNextSetting = this.totalSelectedLines <= this.totalMultiLinesSelected;
      this.npaNpxNumber = [];
      this.getNpanXXForMultifield();
    }else{
      if(this.totalMultiLinesSelected > 0){
        this.multiSelectedNpa.length-=1;
        this.totalMultiLinesSelected = this.totalMultiLinesSelected - line.availableCount;
      }
    }
    
  }

  multiSelectCheckbox() {
    if (this.selectToggle) {
      this.multiSelectedNpa = [];
      this.npaNpxResponse = _.forEach(this.npaNpxResponse, (item) => {
        item.isLineSelected = true;
        this.multiSelectedNpa.push(item);
      });
      this.totalMultiLinesSelected = _.sumBy(this.multiSelectedNpa, function (item) { return +item.availableCount; });
      this.enableNextSetting = this.totalSelectedLines <= this.totalMultiLinesSelected;
    } else {
      this.multiSelectedNpa = [];
      this.totalMultiLinesSelected = 0;
      this.npaNpxResponse = _.forEach(this.npaNpxResponse, (item) => {
        item.isLineSelected = false;
      });
      this.enableNextSetting = this.totalSelectedLines <= this.totalMultiLinesSelected;
    }
    this.npaNpxNumber = [];
    this.getNpanXXForMultifield();
    this.selectToggle = !this.selectToggle;
  }

  ngOnDestroy() {
    this.multiSelectedNpa = [];
    this.totalMultiLinesSelected = 0;
  }
  singleSettingPopulateData() {
    this.manageLineService.notifyChangeNumberFlow.next({ 'id': 'assignIndividual' });
  }
  getNpanXXForMultifield() {
    for (let item of this.multiSelectedNpa) {
      for (let j = 0; j < item.availableCount; j++) {
        if (this.npaNpxNumber.indexOf(item.availableCount) === -1) {
          this.npaNpxNumber.push(item.npaNxx);
        } else {
          this.npaNpxNumber = this.npaNpxNumber.filter((element) => {
            return element !== item.npaNxx;
          });
        }
      }
    }
  }
  lookUpFieldUpdater() {
    this.isVisibleLookUpField = true;
    const lookUpBody = {
      zipCodes: this.changeNumberByDD[0].name,
      areaCodeValues: '',
      isnpxErrorMsgEnable: '',
      errorMessage: '',
      areaCodeValidation: COMMON_CONSTANTS.DIGITS.THREE,
    };
    this.lookUpFieldArray.push(lookUpBody);
  }
  lookUpFieldRemover(npa, index) {
    this.lookUpFieldArray.splice(index, 1);
    _.remove(this.npaNpxResponse, (item: any) => {
      return item.uniqueId === npa;
    });
    if (this.lookUpFieldArray.length === 0) {
      this.isVisibleLookUpField = false;
    }
    this.areaNumberCount = this.lookUpFieldArray.length === 0 ? 1 : this.lookUpFieldArray.length;
  }
}
